import { render } from "./SimpleRadio.vue?vue&type=template&id=b8feb268&scoped=true"
import script from "./SimpleRadio.vue?vue&type=script&lang=js"
export * from "./SimpleRadio.vue?vue&type=script&lang=js"

import "./SimpleRadio.vue?vue&type=style&index=0&id=b8feb268&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8feb268"]])

export default __exports__